import { create } from 'zustand';

type TrustlyKycState = {
    shouldProceedToWithdrawal: boolean;
    setShouldProceedToWithdrawal: (value: boolean) => void;
    resetShouldProceedToWithdrawal: () => void;
};

export const useTrustlyKycStore = create<TrustlyKycState>(set => ({
    shouldProceedToWithdrawal: false,
    setShouldProceedToWithdrawal: value => set({ shouldProceedToWithdrawal: value }),
    resetShouldProceedToWithdrawal: () => set({ shouldProceedToWithdrawal: false }),
}));
